import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AbookButton } from '@app/shared/components/abook-button/abook-button';
import { AbookConfirmOptions } from '../abook-dialog.models';
@Component({
  selector: 'app-abook-confirm-dialog',
  imports: [MatDialogModule, AbookButton],
  templateUrl: './abook-confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './abook-confirm-dialog.component.scss',
})
export class AbookConfirmDialogComponent {
  protected dialogRef = inject(MatDialogRef<AbookConfirmDialogComponent>);
  protected data = inject<AbookConfirmOptions>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
